import styles from "./style/Themes.module.css";
import { classNames } from "../../../../../helpers/classNames";
import { useDispatch } from "react-redux";
import { selectElement } from "../../../../../redux/slice/themeSlice";
import { clickOnElemnt, rgba } from "../../../../../helpers";
import { useSelector } from "react-redux";

const Navbar = () => {
  const dispatch = useDispatch();
  const { theme, selectedElement } = useSelector((state) => state?.themeProvider);

  return (
    <div className="space-y-1">
      {Array.from({ length: 1 }, (_, i) => (
        <div
          key={i}
          class={classNames(
            "nav-menu-item group cursor-pointer text-sm flex items-center gap-1 group hover:text-white hover:bg-primary rounded overflow-hidden p-1 transition-all duration-200 text-sidebar editable-element",
            styles["nav-menu-item"]
          )}
          id="menuItem"
          onClick={(e) => {
            dispatch(selectElement(clickOnElemnt({ event: e })));
          }}
          style={{
            "--bg": rgba(theme?.menuItem?.backgroundColor),
            "--hover-bg": theme?.menuItem?.backgroundColor ? rgba(theme?.menuItem?.backgroundColorHover) : "#CA4D55",
          }}>
          <div
            className={classNames(
              "nav-menu-icon w-8 h-8 flex justify-center items-center text-sm transition-all duration-200 group-hover:!text-white text-primary",
              styles["nav-menu-icon"]
            )}
            style={{
              "--icon-color": rgba(theme?.menuItem?.iconColor),
              "--hover-icon-color": rgba(theme?.menuItem?.iconColorHover),
            }}>
            <i className={classNames("fa-fw text-base fa-light fa-graduation-cap")}></i>
          </div>
          <div
            className={classNames("nav-menu-label", styles["nav-menu-label"])}
            style={{
              "--color": theme?.menuItem?.color ? rgba(theme?.menuItem?.color) : "#172933",
              "--hover-color": theme?.menuItem?.colorHover ? rgba(theme?.menuItem?.colorHover) : "white",
            }}>
            Menu item
          </div>
        </div>
      ))}
    </div>
  );
};

export default Navbar;
